import { configureStore } from '@reduxjs/toolkit';
import DataReducer from './Reducer/DataReducer';

export const store = configureStore({
    reducer : {
        data : DataReducer,
    }
})
